module.exports = __webpack_public_path__ + "img/s.117cb45f.jpg";